import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "car-data-page" }
const _hoisted_2 = { class: "button-row" }
const _hoisted_3 = {
  key: 0,
  class: "pagination-row"
}
const _hoisted_4 = { class: "page-info" }
const _hoisted_5 = { class: "column-header" }
const _hoisted_6 = { class: "arr" }
const _hoisted_7 = { class: "column-header" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "column-header" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "column-header" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "column-header" }
const _hoisted_14 = { key: 1 }

import { ref } from 'vue'
import { ElMessage } from 'element-plus'
import {
  getCqData,
  createCqDatum,
  updateCqDatum,
  deleteCqDatum,
} from '@/api/cq'
// import { centsToDollars } from '../helpers/strings';

interface CqDatum {
  model_id: number
  model_make_id: string
  model_name: string
  model_trim: string
  model_year: number
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CarData',
  setup(__props) {

const filters = ref({
  model_id: '',
  model_make_id: '',
  model_name: '',
  model_trim: '',
  model_year: '',
})

const paginatedRecords = ref<CqDatum[]>([])
const currentPage = ref(1)
const totalPages = ref(1)
const sortBy = ref('model_id')
const sortOrder = ref('asc')
const showTable = ref(false)
const showLoadNext = ref(false)
const showPagination = ref(false)
const editableRow = ref<number | null>(null)
const editData = ref<Partial<CqDatum>>({})

const rules: any = {
  model_make_id: [
    { required: true, message: 'Please enter Model Make ID', trigger: 'blur' },
  ],
  model_name: [
    { required: true, message: 'Please enter Model Name', trigger: 'blur' },
  ],
  model_trim: [],
  model_year: [],
  // model_trim: [
  //   { required: true, message: "Please enter Model Trim", trigger: "blur" },
  // ],
  // model_year: [
  //   { required: true, message: "Please enter Model Y.ear", trigger: "blur" },
  // ],
}

const applyFilters = () => {
  currentPage.value = 1
  fetchRecords()
}

const fetchRecords = async () => {
  const params = {
    sortBy: sortBy.value,
    sortOrder: sortOrder.value,
    page: currentPage.value,
    perPage: 40,
    ...filters.value,
  }
  try {
    const response = await getCqData(params)
    paginatedRecords.value = response.data.data
    totalPages.value = response.data.meta.last_page || 1
    showLoadNext.value =
      response.data.meta.current_page < response.data.meta.last_page
    showPagination.value = true
  } catch (error) {
    console.error('Error fetching records:', error)
    ElMessage.error('Failed to fetch records')
  }
}

const toggleTable = () => {
  if (!showTable.value) fetchRecords()
  showTable.value = !showTable.value
}

const handleSortChange = ({ prop, order }: { prop: string; order: string }) => {
  if (prop && order) {
    sortBy.value = prop
    sortOrder.value = order === 'ascending' ? 'asc' : 'desc'
    fetchRecords()
  }
}

const loadPrev = () => {
  if (currentPage.value > 1) {
    currentPage.value--
    fetchRecords()
  }
}

const loadNext = () => {
  if (showLoadNext.value) {
    currentPage.value++
    fetchRecords()
  }
}

const newRecord = ref<Omit<CqDatum, 'model_id'>>({
  model_make_id: '',
  model_name: '',
  model_trim: '',
  model_year: 0,
})

const createRecord = async () => {
  try {
    await createCqDatum(newRecord.value)
    ElMessage.success('Record created successfully')
    fetchRecords()
  } catch (error) {
    console.error('Error creating record:', error)
    ElMessage.error('Failed to create record')
  }
}

const editRow = (row: CqDatum) => {
  editableRow.value = row.model_id
  editData.value = { ...row }
}

const saveRow = async (row: CqDatum) => {
  try {
    editData.value.model_make_id = editData.value.model_make_id?.toLowerCase()
    await updateCqDatum(row.model_id, editData.value)
    Object.assign(row, editData.value)
    editableRow.value = null
    ElMessage.success('Record updated successfully')
  } catch (error) {
    console.error('Error updating record:', error)
    ElMessage.error('Failed to update record')
  }
}

const cancelEdit = () => {
  editableRow.value = null
  editData.value = {}
}

const deleteRow = async (row: CqDatum) => {
  try {
    await deleteCqDatum(row.model_id)
    fetchRecords()
    ElMessage.success('Record deleted successfully')
  } catch (error) {
    console.error('Error deleting record:', error)
    ElMessage.error('Failed to delete record')
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[30] || (_cache[30] = _createElementVNode("h1", null, "Car Data", -1)),
    _createVNode(_component_el_form, {
      model: newRecord.value,
      rules: rules,
      ref: "createForm",
      "label-width": "120px",
      class: "form-container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "Model Make ID",
          prop: "model_make_id"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: newRecord.value.model_make_id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newRecord.value.model_make_id) = $event)),
              placeholder: "required field"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Model Name",
          prop: "model_name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: newRecord.value.model_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newRecord.value.model_name) = $event)),
              placeholder: "required field"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Model Trim",
          prop: "model_trim"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: newRecord.value.model_trim,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newRecord.value.model_trim) = $event)),
              placeholder: "optional field"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "Model Year",
          prop: "model_year"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: newRecord.value.model_year,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newRecord.value.model_year) = $event)),
              type: "number",
              placeholder: "optional field"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: createRecord
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode("Create")
          ])),
          _: 1,
          __: [18]
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: toggleTable
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(showTable.value ? 'Hide Data' : 'Fetch Records'), 1)
        ]),
        _: 1
      })
    ]),
    (showPagination.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_button, {
            disabled: currentPage.value <= 1,
            onClick: loadPrev,
            type: "primary",
            size: "small"
          }, {
            default: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode(" Prev ")
            ])),
            _: 1,
            __: [19]
          }, 8, ["disabled"]),
          _createElementVNode("span", _hoisted_4, "Page " + _toDisplayString(currentPage.value) + " of " + _toDisplayString(totalPages.value), 1),
          _createVNode(_component_el_button, {
            disabled: !showLoadNext.value,
            onClick: loadNext,
            type: "primary",
            size: "small"
          }, {
            default: _withCtx(() => _cache[20] || (_cache[20] = [
              _createTextVNode(" Next ")
            ])),
            _: 1,
            __: [20]
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true),
    (showTable.value)
      ? (_openBlock(), _createBlock(_component_el_table, {
          key: 1,
          data: paginatedRecords.value,
          style: {"width":"100%","min-height":"300px"},
          "empty-text": "No records found",
          onSortChange: handleSortChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "model_id",
              label: "Model ID",
              sortable: "custom",
              width: "80"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[21] || (_cache[21] = _createTextVNode(" Model ID ")),
                  _createVNode(_component_el_input, {
                    modelValue: filters.value.model_id,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.value.model_id) = $event)),
                    placeholder: "Filter",
                    size: "small",
                    style: {"width":"70px"},
                    onInput: applyFilters,
                    onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(({ row }) => [
                _createElementVNode("span", _hoisted_6, _toDisplayString(row.model_id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "model_make_id",
              label: "Model Make ID",
              sortable: "custom"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _cache[22] || (_cache[22] = _createTextVNode(" Model Make ID ")),
                  _createVNode(_component_el_input, {
                    modelValue: filters.value.model_make_id,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filters.value.model_make_id) = $event)),
                    placeholder: "Filter",
                    size: "small",
                    style: {"margin-left":"10px"},
                    onInput: applyFilters,
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(({ row }) => [
                (editableRow.value === row.model_id)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: editData.value.model_make_id,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((editData.value.model_make_id) = $event)),
                      size: "small"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(row.model_make_id), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "model_name",
              label: "Model Name",
              sortable: "custom"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _cache[23] || (_cache[23] = _createTextVNode(" Model Name ")),
                  _createVNode(_component_el_input, {
                    modelValue: filters.value.model_name,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filters.value.model_name) = $event)),
                    placeholder: "Filter",
                    size: "small",
                    style: {"margin-left":"10px"},
                    onInput: applyFilters,
                    onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(({ row }) => [
                (editableRow.value === row.model_id)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: editData.value.model_name,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((editData.value.model_name) = $event)),
                      size: "small"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(row.model_name), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "model_trim",
              label: "Model Trim",
              sortable: "custom"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _cache[24] || (_cache[24] = _createTextVNode(" Model Trim ")),
                  _createVNode(_component_el_input, {
                    modelValue: filters.value.model_trim,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((filters.value.model_trim) = $event)),
                    placeholder: "Filter",
                    size: "small",
                    style: {"margin-left":"10px"},
                    onInput: applyFilters,
                    onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(({ row }) => [
                (editableRow.value === row.model_id)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: editData.value.model_trim,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((editData.value.model_trim) = $event)),
                      size: "small"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(row.model_trim), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "model_year",
              label: "Model Year",
              sortable: "custom",
              width: "100"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _cache[25] || (_cache[25] = _createTextVNode(" Model Year ")),
                  _createVNode(_component_el_input, {
                    modelValue: filters.value.model_year,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((filters.value.model_year) = $event)),
                    placeholder: "Filter",
                    size: "small",
                    style: {"margin-left":"10px"},
                    onInput: applyFilters,
                    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              default: _withCtx(({ row }) => [
                (editableRow.value === row.model_id)
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      modelValue: editData.value.model_year,
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editData.value.model_year) = $event)),
                      size: "small"
                    }, null, 8, ["modelValue"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row.model_year), 1))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Actions",
              width: "180"
            }, {
              default: _withCtx(({ row }) => [
                (editableRow.value === row.model_id)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "success",
                        onClick: ($event: any) => (saveRow(row))
                      }, {
                        default: _withCtx(() => _cache[26] || (_cache[26] = [
                          _createTextVNode(" Save ")
                        ])),
                        _: 2,
                        __: [26]
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "warning",
                        onClick: cancelEdit
                      }, {
                        default: _withCtx(() => _cache[27] || (_cache[27] = [
                          _createTextVNode(" Cancel ")
                        ])),
                        _: 1,
                        __: [27]
                      })
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: ($event: any) => (editRow(row))
                      }, {
                        default: _withCtx(() => _cache[28] || (_cache[28] = [
                          _createTextVNode(" Edit ")
                        ])),
                        _: 2,
                        __: [28]
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "danger",
                        onClick: ($event: any) => (deleteRow(row))
                      }, {
                        default: _withCtx(() => _cache[29] || (_cache[29] = [
                          _createTextVNode(" Delete ")
                        ])),
                        _: 2,
                        __: [29]
                      }, 1032, ["onClick"])
                    ], 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})